/**
 * Firebase-проект bilload-c5d8d (тот же, что у мобильного приложения) — веб-клиент
 * зарегистрирован там же для единого механизма push-уведомлений (FCM для веба и
 * мобилки вместо отдельного самописного Web Push). Значения ниже — публичная
 * идентификация клиента (как apiKey у мобильных google-services.json/
 * GoogleService-Info.plist), не секрет — Firebase их проверяет только вместе с
 * правилами доступа проекта.
 */
export const firebaseConfig = {
  apiKey: 'AIzaSyClreAj09Hiry1C_i1pGq9ifWD4nae0F40',
  authDomain: 'bilload-c5d8d.firebaseapp.com',
  projectId: 'bilload-c5d8d',
  storageBucket: 'bilload-c5d8d.firebasestorage.app',
  messagingSenderId: '884815989380',
  appId: '1:884815989380:web:fd2a91c816a1a5f84a10d1',
  measurementId: 'G-7XNLHFFFLN',
};
